class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  connectedCallback() {
    this.discountCodeChangeListener = this.onDiscountCodeChange.bind(this);
    document.body.addEventListener('docapp-discount-code-submit', this.discountCodeChangeListener);
    document.body.addEventListener('docapp-discount-removing', this.discountCodeChangeListener);
  }

  disconnectedCallback() {
    document.body.removeEventListener('docapp-discount-code-submit', this.discountCodeChangeListener);
    document.body.removeEventListener('docapp-discount-removing', this.discountCodeChangeListener);
  }

  onDiscountCodeChange() {
    this.setActiveElement(document.activeElement);
    const sections = this.getSectionsToRender().map((section) => section.id).join(',');
    const sections_url = window.location.pathname;
    
    const fetchUrl = `/?sections=${encodeURIComponent(sections)}&sections_url=${encodeURIComponent(sections_url)}`;
    console.log('🔄 Fetch discount code:', fetchUrl);

    setTimeout(() => {
      fetch(fetchUrl, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
        },
      })
        .then((response) => response.json())
        .then((response) => {
          this.renderContents({ sections: response });
        })
        .catch((error) => {
          console.error('Erreur discount code:', error);
        });
    }, 3000);
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn =
          (this.classList.contains('is-empty') && this.querySelector('.drawer__inner-empty')) ||
          document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        if (containerToTrapFocusOn) trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.classList.remove('is-empty');
    this.productId = parsedState.id;
    
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      
      if (sectionElement) {
        const newContent = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        sectionElement.innerHTML = newContent;
      }
    });

    setTimeout(() => {
      const overlay = this.querySelector('#CartDrawer-Overlay');
      if (overlay) overlay.addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

class CartFooterBox extends HTMLElement {
  constructor() {
    super();

    this.container = this.closest('.drawer__footer-top');
    this.closeButton = this.querySelector('.drawer__footer-top-hide-text');
  }

  connectedCallback() {
    this.closeButton.addEventListener('click', this.close.bind(this));
  }

  close() {
    this.container.classList.remove('drawer__footer-top--active');
  }
}

customElements.define('cart-footer-box', CartFooterBox);

class ModalJs extends HTMLElement {
  constructor() {
      super();

      this.modal = this.querySelector('.modal__wrapper');
      this.opener = this.querySelector('.modal__opener');
      this.closers = this.querySelectorAll('.modal__closer, .modal__overlay');
  }

  connectedCallback() {
      this.setOpener();
      this.setClosers();
  }

  setOpener(){
      this.opener?.addEventListener('click', this.openModal.bind(this));
  }

  setClosers() {
      this.closers.forEach(closer => {
          closer.addEventListener('click', this.closeModal.bind(this));
      });
  }
          
  openModal(){
      this.modal.classList.add('modal--open');
  }

  closeModal() {
      this.modal.classList.remove('modal--open');
  }
}

customElements.define('modal-js', ModalJs);

class ModalJsOpener extends HTMLElement {
  constructor() {
    super();

    this.modal = document.querySelector(this.getAttribute('data-modal-selector'));
    this.button = this.querySelector('button');
  }

  connectedCallback() {
    this.button.addEventListener('click', this.openModal.bind(this));
  }

  openModal() {
    if(!this.modal) return;
    this.modal.openModal();
  }
}

customElements.define('modal-js-opener', ModalJsOpener);